/**
 * Redirects to the event switcher only. The event switcher page will:
 * - If no token: redirect to login ("/")
 * - If token: fetch events and show the event list (never the login form)
 */
export function redirectToEventSwitcher(): void {
  if (isOnEventSwitcher()) return;
  globalThis.location.replace("/select-event");
}

export function isOnEventSwitcher(): boolean {
  if (typeof globalThis === "undefined") return false;
  const pathname = globalThis.location.pathname || "";
  return pathname === "/select-event";
}

export function redirectToNoAccessPage(): void {
  if (isOnNoAccessPage()) return;
  globalThis.location.replace("/no-access");
}

export function isOnNoAccessPage(): boolean {
  if (typeof globalThis === "undefined") return false;
  const pathname = globalThis.location.pathname || "";
  return pathname === "/no-access";
}
